import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import './index.css';
import {getComponentName} from '../../common/utils/namespace';
import {createNamespace} from '../../common/utils';
import Col from '../col';
import Row from '../row';
import Icon from '../icon';
import {noop} from '../../common/utils';

var _createNamespace = createNamespace('nav-bar'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    b = _createNamespace2[0];

var InnerIcon = {
    functional: true,
    render: function render(h, config) {
        var props = config.props;

        var _click = function click(e, index) {
            props.click ? props.click(index) : noop;
        };

        return h('icon', {
            class: b('icon'),
            attrs: {
                name: props.item,
                size: props.size || 32
            },
            on: {
                click: function click(e) {
                    return _click(e, props.id);
                }
            }
        });
    }
};

function clickResolver(where) {
    var _this = this;

    return function(index) {
        _this.$emit('click', ''.concat(where, '-').concat(index));
    };
}

function iconResolver(iconConfig) {
    var currentItems = !Array.isArray(iconConfig) ? [iconConfig] : iconConfig;
    return currentItems
        .filter(function(item) {
            return item;
        })
        .map(function(item) {
            return typeof item === 'string'
                ? {
                      name: item
                  }
                : item;
        });
}

export default {
    name: getComponentName('NavBar'),
    props: {
        title: {
            type: String,
            default: ''
        },
        leftIcon: {
            type: [String, Array, Object],
            default: 'arr-left'
        },
        rightIcon: {
            type: [String, Array, Object],
            default: 'home'
        }
    },
    render: function render() {
        var _this2 = this;

        var h = arguments[0];
        var $slots = this.$slots;
        return h(
            'row',
            {
                attrs: {
                    align: 'center',
                    justify: 'space-between'
                },
                class: b()
            },
            [
                h(
                    'row',
                    {
                        class: b('left')
                    },
                    [
                        $slots.left ||
                            iconResolver(this.leftIcon).map(function(_ref, key) {
                                var name = _ref.name,
                                    size = _ref.size;
                                return h(
                                    'row',
                                    {
                                        attrs: {
                                            align: 'center',
                                            justify: 'center'
                                        },
                                        class: b('btn', ['left']),
                                        key: key
                                    },
                                    [
                                        h(InnerIcon, {
                                            attrs: {
                                                click: _this2.clickResolver('left'),
                                                id: key,
                                                item: name,
                                                size: size
                                            }
                                        })
                                    ]
                                );
                            })
                    ]
                ),
                h(
                    'col',
                    {
                        class: b('title')
                    },
                    [
                        $slots.title ||
                            h(
                                'h1',
                                {
                                    class: b('title-text')
                                },
                                [this.title]
                            )
                    ]
                ),
                h(
                    'row',
                    {
                        class: b('right')
                    },
                    [
                        $slots.right ||
                            iconResolver(this.rightIcon).map(function(_ref2, key) {
                                var name = _ref2.name,
                                    size = _ref2.size;
                                return h(
                                    'row',
                                    {
                                        attrs: {
                                            align: 'center',
                                            justify: 'center'
                                        },
                                        class: b('btn', ['right']),
                                        key: key
                                    },
                                    [
                                        h(InnerIcon, {
                                            attrs: {
                                                click: _this2.clickResolver('right'),
                                                id: key,
                                                item: name,
                                                size: size
                                            }
                                        })
                                    ]
                                );
                            })
                    ]
                )
            ]
        );
    },
    methods: {
        clickResolver: clickResolver
    },
    components: {
        Icon: Icon,
        Col: Col,
        Row: Row
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
